/**
 * Composant Tabs
 * Gère les onglets avec navigation par hash URL
 */

import { logger } from '../../core/base.js';

/**
 * Initialise les tabs
 */
export function initTabs() {
    document.querySelectorAll('.ui-tabs').forEach(tabs => {
        function updateClassBasedOnHash() {
            const hash = window.location.hash || tabs.querySelector('li:first-child a').hash;

            const elements = tabs.querySelectorAll("li");
            elements.forEach(li => {
                const a = li.querySelector('a');

                if (a.hash === hash) {
                    li.classList.add("is-active");
                } else {
                    li.classList.remove("is-active");
                }
            });

            const tabContents = tabs.parentElement.querySelectorAll('.arcate-tab-content').forEach(tabContent => {
                if (`#${tabContent.id}` === hash) {
                    tabContent.classList.add('is-active');
                } else {
                    tabContent.classList.remove('is-active');
                }
            });
        }

        // Vérifier au chargement de la page
        updateClassBasedOnHash();

        // Écouter les changements d'URL (changement du fragment)
        window.addEventListener("hashchange", updateClassBasedOnHash);
    });

    logger.debug('Tabs initialized');
}

// Auto-initialisation
document.addEventListener('DOMContentLoaded', initTabs);
